import MyService from '../../service';

const UserGroupApi = {
  getOne: async (userGroupId) => {
    const result = await MyService.getRequestData(`/usergroup/${userGroupId}`);
    if (result && result.data) {
      return result.data;
    }
    return [];
  },
  getAllUserGroup: async () => {
    const result = await MyService.getRequestData('/usergroup');
    if (result && result.data) {
      return result.data;
    }
    return [];
  },
  update: async (params) => {
    console.log('params', params);
    if (!params) return null;
    const result = await MyService.postRequestData(
      '/usergroup/update',
      params
    ).catch((err) => console.log(err));
    return result;
  },
  create: async (data) => {
    const result = await MyService.postRequestData(
      '/usergroup/create',
      data
    ).catch((err) => console.log(err));
    return result;
  },
};

export default UserGroupApi;
